*[data-testid="toastText1"] {
  white-space: normal;
}
